const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { consultation: consultApi } = require('@doctoroncallcom/api')
const {
  GET_ADMIN_CONSULTATIONS_LIST,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL,
  GET_ADMIN_CONSULTATION,
  CREATE_ADMIN_CONSULTATION,
  UPDATE_ADMIN_CONSULTATION,
  DELETE_ADMIN_CONSULTATION,
  UPDATE_STATUS_ADMIN_CONSULTATION,

  GET_CONSULTATIONS_LIST,
  GET_AVAILABLE_CONSULTATIONS_LIST,
  CREATE_CONSULTATION,
  GET_CONSULTATION_HISTORY_LIST,
  GET_CONSULTATION_HISTORY_DETAILS,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST,
  GET_DOCTOR_CONSULTATION_OVERVIEW,
  ASSIGN_DOC_TO_CONSULTATION,
  SET_CONSULTATION_PREFERENCE,
  GET_PATIENT_RECORD,
  POST_DOCTOR_NOTES,
  POST_DOCTOR_MC,
  POST_DOCTOR_REFERRAL,
  END_DOCTOR_CONSULTATION,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR,
  GET_DOCTOR_TWILIO_TOKEN,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED,
  GET_MD_REFERRAL_NEW_LINK,
  GET_MD_MC_NEW_LINK,
  CHECK_PATIENT_CONSULTATION_STATUS,
  VERIFY_TRANSACTION_AMOUNT,
  GET_PRESCRIPTION_ID,
  POST_REGENERATE_AGORA_TOKEN,
} = require('./constants')

const {
  getAdminConsultationsListSuccess,
  getAdminConsultationsListError,
  sendAdminConsultationsCSVEmailSuccess,
  sendAdminConsultationsCSVEmailError,
  getAdminConsultationSuccess,
  getAdminConsultationError,
  createAdminConsultationSuccess,
  createAdminConsultationError,
  updateAdminConsultationSuccess,
  updateAdminConsultationError,
  deleteAdminConsultationSuccess,
  deleteAdminConsultationError,
  updateStatusAdminConsultationSuccess,
  updateStatusAdminConsultationError,

  getConsultationSuccess,
  getConsultationError,
  getAvailableConsultationsSuccess,
  getAvailableConsultationsError,
  createConsultationSuccess,
  createConsultationError,
  getConsultationHistoryListSuccess,
  getConsultationHistoryListError,
  getConsultationHistoryDetailsSuccess,
  getConsultationHistoryDetailsError,
  getDoctorConsultationHistoryListSuccess,
  getDoctorConsultationHistoryListError,
  getDoctorConsultationOverviewSuccess,
  getDoctorConsultationOverviewError,
  assignDocToConsultationSuccess,
  assignDocToConsultationError,
  setConsultationPreferenceSuccess,
  setConsultationPreferenceError,
  getPatientRecordSuccess,
  getPatientRecordError,
  postDoctorNotesSuccess,
  postDoctorNotesError,
  postDoctorMCSuccess,
  postDoctorMCError,
  postDoctorReferralSuccess,
  postDoctorReferralError,
  endDoctorConsultationSuccess,
  endDoctorConsultationError,
  sendAudioCallRequestByDoctorSuccess,
  sendAudioCallRequestByDoctorError,
  getDoctorTwilioTokenSuccess,
  getDoctorTwilioTokenError,
  postDoctorConsultationTimeLapsedSuccess,
  postDoctorConsultationTimeLapsedError,
  getMDReferralNewLinkSuccess,
  getMDReferralNewLinkError,
  getMDMcNewLinkSuccess,
  getMDMcNewLinkError,
  checkPatientConsultationStatusSuccess,
  checkPatientConsultationStatusError,
  verifyTransactionAmountSuccess,
  verifyTransactionAmountError,
  getPrescriptionIdSuccess,
  getPrescriptionIdError,
  postRegenerateAgoraTokenSuccess,
  postRegenerateAgoraTokenError,
} = require('./actions')

const getAdminConsultationsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ADMIN_CONSULTATIONS_LIST),
  mergeMap(action => consultApi.getAdminConsultationsListApi(api, {
    type: action.payload.type,
    take: action.payload.take,
    skip: action.payload.skip,
    from: action.payload.from,
    to: action.payload.to,
    key: action.payload.key,
    status: action.payload.status,
    search: action.payload.search,
    userId: action.payload.userId,
    doctorId: action.payload.doctorId,
    hospitalId: action.payload.hospitalId,
    manual: action.payload.manual,
    download: action.payload.download,
    hospitalReferral: action.payload.hospitalReferral,
    id: action.payload.id,
  })
    .then(response => getAdminConsultationsListSuccess(response.data))
    .catch(error => getAdminConsultationsListError(error))),
)

const sendAdminConsultationsCSVEmail = (action$, state$, { api }) => action$.pipe(
  ofType(SEND_ADMIN_CONSULTATIONS_CSV_EMAIL),
  mergeMap(action => consultApi.getAdminConsultationsListApi(api, {
    type: action.payload.type,
    take: action.payload.take,
    skip: action.payload.skip,
    from: action.payload.from,
    to: action.payload.to,
    key: action.payload.key,
    status: action.payload.status,
    search: action.payload.search,
    userId: action.payload.userId,
    doctorId: action.payload.doctorId,
    hospitalId: action.payload.hospitalId,
    manual: action.payload.manual,
    download: action.payload.download,
    hospitalReferral: action.payload.hospitalReferral,
    id: action.payload.id,
  })
    .then(response => sendAdminConsultationsCSVEmailSuccess(response))
    .catch(error => sendAdminConsultationsCSVEmailError(error))),
)

const getAdminConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ADMIN_CONSULTATION),
  mergeMap(action => consultApi.getAdminConsultationApi(api, action.payload.id)
    .then(response => getAdminConsultationSuccess(response.data))
    .catch(error => getAdminConsultationError(error))),
)

const createAdminConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_ADMIN_CONSULTATION),
  mergeMap(action => consultApi.createAdminConsultationApi(api, action.payload.caseData)
    .then(response => createAdminConsultationSuccess(response.data))
    .catch(error => createAdminConsultationError(error))),
)

const updateAdminConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ADMIN_CONSULTATION),
  mergeMap(action => consultApi.updateAdminConsultationApi(api, action.payload.id, action.payload.caseData)
    .then(response => updateAdminConsultationSuccess(response.data))
    .catch(error => updateAdminConsultationError(error))),
)

const deleteAdminConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_ADMIN_CONSULTATION),
  mergeMap(action => consultApi.deleteAdminConsultationApi(api, action.payload.id)
    .then(response => deleteAdminConsultationSuccess(response.data))
    .catch(error => deleteAdminConsultationError(error))),
)

const updateStatusAdminConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_STATUS_ADMIN_CONSULTATION),
  mergeMap(action => consultApi.updateStatusAdminConsultationApi(api, action.payload.id, action.payload.bodyData)
    .then(response => updateStatusAdminConsultationSuccess(response.data))
    .catch(error => updateStatusAdminConsultationError(error))),
)

const getConsultationsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CONSULTATIONS_LIST),
  mergeMap(() => consultApi.getConsultationsListApi(api)
    .then(response => getConsultationSuccess(response.data))
    .catch(error => getConsultationError(error))),
)

const getAvailableConsultationsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_AVAILABLE_CONSULTATIONS_LIST),
  // eslint-disable-next-line max-len
  mergeMap(action => consultApi.getAvailableConsultationsListApi(api, { status: action.payload.status })
    .then(response => getAvailableConsultationsSuccess(response.data))
    .catch(error => getAvailableConsultationsError(error))),
)

const createConsultation = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_CONSULTATION),
  mergeMap(action => consultApi.postConsultationApi(api, action.payload.data)
    .then(response => createConsultationSuccess(response.data))
    .catch(error => createConsultationError(error))),
)

const getConsultationsHistoryList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CONSULTATION_HISTORY_LIST),
  mergeMap(action => consultApi.getConsultationsHistoryListApi(api, {
    type: action.payload.type,
    from: action.payload.from,
    to: action.payload.to,
    key: action.payload.key,
  })
    .then(response => getConsultationHistoryListSuccess(response.data))
    .catch(error => getConsultationHistoryListError(error))),
)

const getConsultationHistoryDetails = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CONSULTATION_HISTORY_DETAILS),
  mergeMap(action => consultApi.getConsultationHistoryDetailsApi(api, action.payload.id)
    .then(response => getConsultationHistoryDetailsSuccess(response.data))
    .catch(error => getConsultationHistoryDetailsError(error))),
)

const getDoctorConsultationHistoryList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_CONSULTATION_HISTORY_LIST),
  mergeMap(action => consultApi.getDoctorConsultationsHistoryListApi(api, {
    type: action.payload.type,
    gpBtn: action.payload.gpBtn,
    name: action.payload.name,
    from: action.payload.from,
    to: action.payload.to,
    key: action.payload.key,
  })
    .then(response => getDoctorConsultationHistoryListSuccess(response.data))
    .catch(error => getDoctorConsultationHistoryListError(error))),
)

const getDoctorConsultationOverview = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_CONSULTATION_OVERVIEW),
  mergeMap(action => consultApi.getDoctorConsultationHistoryDetailsApi(api, action.payload.id)
    .then(response => getDoctorConsultationOverviewSuccess(response.data))
    .catch(error => getDoctorConsultationOverviewError(error))),
)

const getPatientConsultationRecordEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PATIENT_RECORD),
  // eslint-disable-next-line max-len
  mergeMap(action => consultApi.getPatientConsultationRecordApi(api, {
    doctorId: action.payload.doctorId,
    hospitalId: action.payload.hospitalId,
    id: action.payload.id,
    take: action.payload.take,
    skip: action.payload.skip,
    mr: action.payload.mr,
    ignoreId: action.payload.ignoreId,
  },
  action.payload.id)
    .then(response => getPatientRecordSuccess(response.data))
    .catch(error => getPatientRecordError(error))),
)

const assignDocToConsultationEpic = (action$, state$, { api }) => action$.pipe(
  ofType(ASSIGN_DOC_TO_CONSULTATION),
  mergeMap(action => consultApi.assignDocToConsultationApi(api, action.payload.id)
    .then(response => assignDocToConsultationSuccess(response.data))
    .catch(error => assignDocToConsultationError(error))),
)

const setConsultationPreferenceEpic = (action$, state$, { api }) => action$.pipe(
  ofType(SET_CONSULTATION_PREFERENCE),
  // eslint-disable-next-line max-len
  mergeMap(action => consultApi.setConsultationPreferenceApi(api, action.payload.id, { mode: action.payload.mode })
    .then(response => setConsultationPreferenceSuccess(response.data))
    .catch(error => setConsultationPreferenceError(error))),
)

const getPrescriptionIdEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRESCRIPTION_ID),
  // eslint-disable-next-line max-len
  mergeMap(action => consultApi.getPrescriptionIdApi(api, action.payload.data, { doctorId: action.payload.doctorId }, action.payload.id)
    .then(response => getPrescriptionIdSuccess(response.data))
    .catch(error => getPrescriptionIdError(error))),
)

const postDoctorNotesEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_NOTES),
  mergeMap(action => consultApi.postDoctorNotesApi(
    api,
    {
      icdId: action.payload.data.icdId,
      diagnosis: action.payload.data.diagnosis,
      alergies: action.payload.data.allergies,
      notes: action.payload.data.notes,
    },
    { doctorId: action.payload.data.doctorId },
    action.payload.data.consultationId,
  )
    .then(response => postDoctorNotesSuccess(response.data))
    .catch(error => postDoctorNotesError(error))),
)

const postDoctorMCEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_MC),
  mergeMap(action => consultApi.postDoctorMCApi(
    api,
    {
      diagnosis: action.payload.diagnosis,
      from: action.payload.from,
      to: action.payload.to,
    },
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => postDoctorMCSuccess(response.data))
    .catch(error => postDoctorMCError(error))),
)

const postDoctorReferralEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_REFERRAL),
  mergeMap(action => consultApi.postDoctorReferralApi(
    api,
    {
      title: action.payload.title,
      department: action.payload.department,
      notes: action.payload.notes,
    },
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => postDoctorReferralSuccess(response.data))
    .catch(error => postDoctorReferralError(error))),
)

const endDoctorConsultationEpic = (action$, state$, { api }) => action$.pipe(
  ofType(END_DOCTOR_CONSULTATION),
  mergeMap(action => consultApi.endDoctorConsultationApi(
    api,
    action.payload.data,
    { doctorId: action.payload.doctorId },
    action.payload.consultationId,
  )
    .then(response => endDoctorConsultationSuccess(response.data))
    .catch(error => endDoctorConsultationError(error))),
)

const sendAudioCallRequestByDocEpic = (action$, state$, { api }) => action$.pipe(
  ofType(SEND_AUDIO_CALL_REQUEST_BY_DOCTOR),
  mergeMap(action => consultApi.audioCallRequestByDoctorApi(
    api,
    { doctorId: action.payload.doctorId },
    action.payload.consultationId,
  )
    .then(response => sendAudioCallRequestByDoctorSuccess(response.data))
    .catch(error => sendAudioCallRequestByDoctorError(error))),
)

const getDoctorTwilioTokensEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_DOCTOR_TWILIO_TOKEN),
  mergeMap(() => consultApi.getDoctorTwilioTokensApi(api)
    .then(response => getDoctorTwilioTokenSuccess(response.data))
    .catch(error => getDoctorTwilioTokenError(error))),
)

const postDocConsultationTimeLapsedEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_DOCTOR_CONSULTATION_TIME_LAPSED),
  mergeMap(action => consultApi.postDocConsultationTimeLapsedApi(
    api,
    {
      timeLapsed: {
        start: action.payload.start,
        end: action.payload.end,
      },
    },
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => postDoctorConsultationTimeLapsedSuccess(response.data))
    .catch(error => postDoctorConsultationTimeLapsedError(error))),
)

const getDoctorMCNewLinkEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_MD_MC_NEW_LINK),
  mergeMap(action => consultApi.postDoctorMCNewLinkApi(
    api,
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => getMDMcNewLinkSuccess(response.data))
    .catch(error => getMDMcNewLinkError(error))),
)

const getDoctorReferralNewLinkEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_MD_REFERRAL_NEW_LINK),
  mergeMap(action => consultApi.postDoctorReferralNewLinkApi(
    api,
    { doctorId: action.payload.doctorId },
    action.payload.id,
  )
    .then(response => getMDReferralNewLinkSuccess(response.data))
    .catch(error => getMDReferralNewLinkError(error))),
)

const checkPatientConsultationDetailsStatusEpic = (action$, state$, { api }) => action$.pipe(
  ofType(CHECK_PATIENT_CONSULTATION_STATUS),
  mergeMap(action => consultApi.getPatientConsultationStatusApi(api, action.payload.id)
    .then(response => checkPatientConsultationStatusSuccess(response.data))
    .catch(error => checkPatientConsultationStatusError(error))),
)

const verifyTransactionAmountEpic = (action$, state$, { api }) => action$.pipe(
  ofType(VERIFY_TRANSACTION_AMOUNT),
  mergeMap(action => consultApi.verifyTransactionAmountApi(api, action.payload.id)
    .then(response => verifyTransactionAmountSuccess(response.data))
    .catch(error => verifyTransactionAmountError(error))),
)

const regenerateAgoraTokenEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_REGENERATE_AGORA_TOKEN),
  // eslint-disable-next-line max-len
  mergeMap(action => consultApi.postRegenerateAgoraTokenApi(api, { regenerate: action.payload.regenerate, status: action.payload.status }, action.payload.consultationId)
    .then(response => postRegenerateAgoraTokenSuccess(response.data))
    .catch(error => postRegenerateAgoraTokenError(error))),
)

module.exports = {
  getAdminConsultationsList,
  sendAdminConsultationsCSVEmail,
  getAdminConsultation,
  createAdminConsultation,
  updateAdminConsultation,
  deleteAdminConsultation,
  updateStatusAdminConsultation,

  getConsultationsList,
  createConsultation,
  getConsultationsHistoryList,
  getConsultationHistoryDetails,
  getDoctorConsultationHistoryList,
  getDoctorConsultationOverview,
  getAvailableConsultationsList,
  assignDocToConsultationEpic,
  setConsultationPreferenceEpic,
  getPatientConsultationRecordEpic,
  postDoctorNotesEpic,
  postDoctorMCEpic,
  postDoctorReferralEpic,
  endDoctorConsultationEpic,
  sendAudioCallRequestByDocEpic,
  getDoctorTwilioTokensEpic,
  postDocConsultationTimeLapsedEpic,
  getDoctorMCNewLinkEpic,
  getDoctorReferralNewLinkEpic,
  checkPatientConsultationDetailsStatusEpic,
  verifyTransactionAmountEpic,
  getPrescriptionIdEpic,
  regenerateAgoraTokenEpic,
}
